export const categories = [
  {
    id: 1,
    name: "Dog Chew Toys",
    slug: "dog-chew-toys",
    description: "Durable chew toys to keep your dog entertained and promote dental health",
    image: "https://images.unsplash.com/photo-1535294435445-d7249524ef2e?w=600&h=400&fit=crop",
    petType: "Dog",
    productCount: 24
  },
  {
    id: 2,
    name: "Interactive Dog Toys",
    slug: "interactive-dog-toys",
    description: "Engaging toys that stimulate your dog's mind and body",
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=400&fit=crop",
    petType: "Dog",
    productCount: 18
  },
  {
    id: 3,
    name: "Cat Toys",
    slug: "cat-toys",
    description: "Fun and exciting toys to keep your feline friend active",
    image: "https://images.unsplash.com/photo-1574158622682-e40e69881006?w=600&h=400&fit=crop",
    petType: "Cat",
    productCount: 32
  },
  {
    id: 4,
    name: "Plush Pet Toys",
    slug: "plush-pet-toys",
    description: "Soft and cuddly plush toys for snuggling and playing",
    image: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=600&h=400&fit=crop",
    petType: "All",
    productCount: 28
  },
  {
    id: 5,
    name: "Rope Toys",
    slug: "rope-toys",
    description: "Strong rope toys perfect for tug-of-war and fetch",
    image: "https://images.unsplash.com/photo-1576201836106-db1758fd1c97?w=600&h=400&fit=crop",
    petType: "Dog",
    productCount: 15
  },
  {
    id: 6,
    name: "Training Toys",
    slug: "training-toys",
    description: "Essential toys and tools for effective pet training",
    image: "https://images.unsplash.com/photo-1544568100-847a948585b9?w=600&h=400&fit=crop",
    petType: "Dog",
    productCount: 12
  },
  {
    id: 7,
    name: "Puzzle Toys",
    slug: "puzzle-toys",
    description: "Challenge your pet's intelligence with puzzle toys",
    image: "https://images.unsplash.com/photo-1568640347023-a616a30bc3bd?w=600&h=400&fit=crop",
    petType: "All",
    productCount: 20
  },
  {
    id: 8,
    name: "Outdoor Pet Toys",
    slug: "outdoor-pet-toys",
    description: "Toys designed for outdoor adventures and exercise",
    image: "https://images.unsplash.com/photo-1558929996-da64ba858215?w=600&h=400&fit=crop",
    petType: "Dog",
    productCount: 22
  }
];

export const getCategoryBySlug = (slug) => {
  return categories.find(category => category.slug === slug);
};
